export const DEFAULT_CURRENCY = 'GBX';

export const mapCurrency = (item) => (
  {
    id: item.minor_unit,
    label: item.major_unit,
  }
);
